import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { scrollBarStyle } from 'src/styles/CommonStyles.styled';

export const ProductSectionContainer = styled.div`
    display:flex;
    flex-direction: column; 
    flex: 1;
    width: ${({width}) => width ? width : '65%'}; 
    margin: ${({ mbMargin }) => (mbMargin ? mbMargin : '0px 10px')};

    ${media.largeDevice`    
        width: ${({ width }) => (width ? width : '60%')};
        margin: 0 auto;
        flex:none;
    `}
    ${media.mediumDevice`    
        width: ${({ width }) => (width ? width : '50%')};
        margin: ${({ mdMargin }) => (mdMargin ? mdMargin : '0 auto')};
        ${'' /* margin: 0 auto; */}
        flex:none;
    `}
    ${media.smalDevice`    
        width: ${({ width }) => (width ? width : '50%')};
        margin: 0 auto;
    `} 
    ${media.mobileDevice`    
        width: 100%; 
        margin: ${({ mbMargin }) => (mbMargin ? mbMargin : '32px auto 0 auto')};
        padding: ${({ mbPadding }) => (mbPadding ? mbPadding : '')}; 
        padding-bottom: ${({ mbPaddingBottom }) => (mbPaddingBottom ? mbPaddingBottom : '')};
        background-color: ${({ backgroundColor }) =>
        backgroundColor ? backgroundColor : ''};
    `}

    @media screen and (min-width: 768px) and (max-width:1023px) and (orientation: landscape){
        margin: ${({ isCondensedView }) => (isCondensedView && '0 0')};
    }
`;

export const ProductHeader = styled.div`
    flex-direction: ${({ displayDirection }) => displayDirection};
    height: ${({ mbHeight }) => (mbHeight ? mbHeight : '62px')};
    display: contents;
    ${media.mobileDevice`    
        width: 100%; 
        margin: ${({ margin }) => (margin ? margin : '32px auto 0 auto')};
        padding: ${({ mbPadding }) => (mbPadding ? mbPadding : '')};
    `}
`;
export const ProductSection = styled.div`
    flex: auto;
    width: 65%;
    margin: ${({ mbMargin }) => (mbMargin ? mbMargin : '0px 10px')};

    ${media.largeDevice`    
        width: ${({ width }) => (width ? width : '60%')};
        margin: 0 auto;
        flex:none;
    `}
    ${media.mediumDevice`    
        width: ${({ width }) => (width ? width : '50%')};
        margin: ${({ mdMargin }) => (mdMargin ? mdMargin : '0 auto')};
        ${'' /* margin: 0 auto; */}
        flex:none;
    `}
    ${media.smalDevice`    
        width: ${({ width }) => (width ? width : '50%')};
        margin: 0 auto;
    `} 
    ${media.mobileDevice`    
        width: 100%; 
        margin: ${({ mbMargin }) => (mbMargin ? mbMargin : '32px auto 0 auto')};
        padding: ${({ mbPadding }) => (mbPadding ? mbPadding : '')}; 
        padding-bottom: ${({ mbPaddingBottom }) => (mbPaddingBottom ? mbPaddingBottom : '')};
        background-color: ${({ backgroundColor }) =>
        backgroundColor ? backgroundColor : ''};
    `}

    @media screen and (min-width: 768px) and (max-width:1023px) and (orientation: landscape){
        margin: ${({ isCondensedView }) => (isCondensedView && '0 0')};
    }
`;

export const ManageFilter = styled.div`
    display: flex;
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '10px'};
    justify-content: space-between;
    align-items: baseline;
    ${media.mobileDevice`
        margin : ${({ margin }) => (margin ? margin : '')};
    `}
    @media screen and (min-width: 820px) and (max-width: 1180px) {
        margin : ${({ margin }) => (margin ? margin : '')};
        margin-left: ${({ ipadmarginLeft }) => (ipadmarginLeft ? ipadmarginLeft : '0px')};
    }
    @media screen and (min-width: 820px) and (max-width: 1180px) and (orientation: landscape) {
        margin : ${({ mbLandscapeMargin }) => (mbLandscapeMargin ? mbLandscapeMargin : '')};
    }

`;

export const CardTitle = styled.div`
    font-family: 'AvenirNextWorld Demi';
    color: #140f4b;
    //font size
    font-size: ${(props) => (props.fontSize ? props.fontSize : '16px')};
`;

export const FilterStyle = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

export const Regular = styled.div`
    color: #140f4b;
    font-size: 14px;
    //font
    font-family: 'AvenirNextWorld Regular';
    margin-right: 5px;
    ${media.mobileDevice`
        /* flex-direction:column; */
        white-space: nowrap;
        margin:${({ margin }) => (margin ? margin : '')};
        /* display:-webkit-inline-box; */

    `}
`;
export const FiltersList = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin: -2px 0px 10px 0px;
    align-items: center;
    ${media.mobileDevice`
        /* flex-direction:column; */
        margin: ${({ isCondensedView }) => (isCondensedView ? '-2px 0px 21px 2px' : '-2px 0px 10px 0px')};
        /* display:-webkit-inline-box; */

    `}
`;
export const DropDownStyle = styled.div`
    display: flex;
    height: 40px;
    width: ${({ width }) => (width ? width : '100%')};
    ${media.largeDevice`
         /* margin: 10px 0px 0 0;
         width:100%; */
    `}
    @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
        height: 40px;
        width: 43%;
    }
    ${media.mediumDevice`
          margin: 10px 0px 0 0;
         width:${({ ipadWidth }) => (ipadWidth ? ipadWidth : '')};
    `}
    ${media.smalDevice`
        margin: 12px 0px 0 0;
    `}
    ${media.mobileDevice`
        margin: 10px 0px 10px 10px;
    `}
`;

export const ClearFilterButton = styled.div`
    display: flex;
    flex-wrap: wrap;
    white-space: noWrap;

    margin-right: ${({ marginLeft }) => (marginLeft ? '5px' : '')};
    justify-content: flex-end;
`;

export const ClearButtonLink = styled.div`
    color: #1010eb;
    font-size: 14px;
    //font
    font-family: 'AvenirNextWorld Demi';
    letter-spacing: -0.11px;
    width: auto;
    height: 24px;
    white-space:    nowrap;
    cursor: pointer;
`;

export const ActionMainContainer = styled.div`
    background-color: #f5f5f5;
    padding: ${({ padding }) => (padding ? padding : '')};
`;

export const ActionPanelContainer = styled.div`
    display: flex;
    justify-content: space-between;
    ${media.mobileDevice`
        flex-direction:column;
        justify-content: space-between;
        width: ${({ width }) => (width ? width : '')};
        margin: ${({ margin }) => (margin ? margin : '')};
        margin-bottom: ${({ marginBottom }) =>
            marginBottom ? marginBottom : ''};
    `}
    ${media.largeDevice`    
        flex-wrap:wrap;
    `}
     ${media.ipadAir`
        margin : ${({ margin }) => (margin ? margin : '')};
        margin-left: ${({ ipadmarginLeft }) => (ipadmarginLeft ? ipadmarginLeft : '0px')};
    `}

    ${media.smalDevice`    
        flex-direction:column;
        justify-content: space-between;
        margin-left: 0px;
    `}
    .p-tabview-nav {
        ${media.mobileDevice`
            width: 350px;
        `}
        @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
            width: 295px;
        }
    }
`;

export const ExpandAllProductGuide = styled.div`
    display: flex;
    align-items: center;
    width: ${({ width }) => (width ? width : 'none')};
    ${media.mobileDevice`
        width: ${({ mbWidth }) => (mbWidth ? mbWidth : '100%')};
        margin: ${({ mbMargin }) => (mbMargin ? mbMargin : '0px')};
           `}
`;
export const AddedCartButton = styled.div`
    width: ${({ width }) => (width ? width : '30px')};
    height: ${({ height }) => (height ? height : '30px')};
    display: flex;
    justify-content: center;
    align-items: center;
    border: ${({ border }) => (border ? border : '1px solid #ebebeb')};
    box-shadow: ${({ boxShadow }) => boxShadow ? boxShadow : '0px 0px 2px #00000029'};
    border-radius: 6px;
    opacity: 1;
    background-color: #ffffff;
    &.disabled {
        opacity: 0.5;
        pointer-events: none;
    }
    ${media.mobileDevice`
        margin-right: 1%;
    `}
`;

export const CartActionItems = styled.div`
    font-family: 'AvenirNextWorld Bold';
    color: #140f4b;
    opacity: 1;
    display: flex;
    flex-direction: row;
    // height: ${({ height }) => (height ? height : '20px')};
    width: ${({ width }) => (width ? width : '20%')};
    font-size: 13px;
    margin: ${({ margin }) => (margin ? margin : '20px')};
    // margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    cursor: ${({ setCursor }) => (setCursor ? setCursor : null)};
    ${media.mobileDevice`
    font-family: 'AvenirNextWorld Demi';
    color: #202124;
    font-size: 20px;
    position: relative;
   // top: -12px;
     margin: ${({ margin }) => (margin ? margin : '20px')};
    // margin-right: ${({ marginRight }) =>
        marginRight ? marginRight : null}; 
    

        
    `}
`;
export const Text = styled.div`
    width: ${({ width }) => (width ? width : '83px')};
    height: ${({ height }) => (height ? height : '20px')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Demi'};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '11px')};
    font-weight: 600;
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0px')};
    color: ${({ color }) => (color ? color : '')};
    white-space: nowrap;
    ${media.mobileDevice`
padding-top : 2px;

        `

    }
`;

export const AddCartIcon = styled.img.attrs((props) => ({
    src: props.mobilePath,
}))`
    width: ${({ width }) => (width ? width : '14px')};
    height: ${({ height }) => (height ? height : '14px')};
    margin-left: ${({ marginLeft }) => marginLeft && marginLeft};

    cursor: pointer;
    ${media.mobileDevice`
        width: ${({ mbWidth }) => (mbWidth ? mbWidth : '16px')};
        height: ${({ mbHeight }) => (mbHeight ? mbHeight : '16x')};
        margin-right : ${({ mbMarginRight }) => (mbMarginRight ? mbMarginRight : '0px')};
    `}
`;

export const StyledSortIcon = styled.div`
    width: 18px;
    height: 16px;
    margin: auto;
    margin-right: 8px;
    ${media.mobileDevice`    
      /* display:none; */
    `}
`;

export const PaginationContainer = styled.div`
    margin-top: ${({ isCondensedView, paginationNoMarginTop }) => 
        (paginationNoMarginTop ? '0px' : isCondensedView ? '5px' : '3px')};
    height: 48px;
    background: ${({ background }) => (background ? background : '#f6f6f6 0% 0% no-repeat padding-box')};
    box-shadow: 0px -1px 12px #00000014, 0px 1px 1px #00000014;
    border-radius: ${({ borderRadius }) => (borderRadius ? borderRadius : '0px 0px 4px 4px')};
    // border: 1px solid #00000014; 
    opacity: 1;
    width: ${({ width }) => (width ? width : ' 48.5%')};
    ${media.mobileDevice`
        flex-direction:column;
        margin: 10px 0px 0px 0px;
        box-shadow: none;
        border-radius: none;        
    `}
    ${media.smalDevice`                    
        height: auto;
        box-shadow: none;
        border-radius: none; 
        // margin-top: 50px;  
    `}
    ${media.mediumDevice`    
        height: auto;
        box-shadow: none;
        border-radius: none;  
        font-size: 13px;  
        // margin-top: 50px;
    `}
`;

export const CartMainContainer = styled.div`
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '15px')};
    height: ${({ cartHeight }) =>
        cartHeight ? cartHeight : 'calc(100vh - 24.125rem)'};
    overflow-y: scroll;
    padding-bottom: 20px;
    ${scrollBarStyle}
    padding: ${({ padding }) => (padding ? padding : '')};
    ${'' /* background-color: white; */}
    background-color: ${({ backgroundColor }) => (backgroundColor ? backgroundColor : '')};
 
    ${media.largeDevice`
        height: ${({ lgCartHeight }) =>
            lgCartHeight ? lgCartHeight : 'calc(100vh - 22.2rem)'};
    `}
    ${media.mediumDevice`
        margin-top:10px;
        height: ${({ mdCartHeight }) =>
            mdCartHeight ? mdCartHeight : 'calc(100vh - 29.5rem)'};
    `}
    ${media.smalDevice`
        margin-top: 8px;
        height: ${({ smCartHeight }) =>
            smCartHeight ? smCartHeight : 'calc(100vh - 28rem)'};
        padding-bottom: 300px;
    `}
    ${media.mobileDevice`
        height: auto;
        margin-bottom: ${(props) => props.marginBottom};
        padding-bottom: 240px;
    `}
 
    @media screen and (min-device-width: 1360px) and (max-device-width: 1370px) and (min-device-height: 1020px) and (max-device-height: 1130px) and (orientation: landscape) {
        height: ${({ landscapeLgCartHeight }) =>
            landscapeLgCartHeight
                ? landscapeLgCartHeight
                : ' calc(100vh - 27.13rem)'};
    }
 
    @media screen and (min-height: 500px) and (min-width: 500px) and (max-width: 1024px) and (orientation: landscape) {
        height: ${({ landscapeSmCartHeight }) =>
            landscapeSmCartHeight
                ? landscapeSmCartHeight
                : 'calc(100vh - 32rem)'};
    }
 
    @media only screen and (min-device-width: 768px) and (max-device-width: 1200px) and (orientation: landscape) {
        padding-bottom: 120px;
        height: ${({ isCondensedView, isFromIndependentProductGuide, bannerHeight }) =>
            isCondensedView ? `calc(100vh - 28rem - ${bannerHeight || '0px'})`: isFromIndependentProductGuide ? `calc(100vh - 29rem - ${bannerHeight || '0px'})` : `calc(100vh - 27rem - ${bannerHeight || '0px'})`};
        &::-webkit-scrollbar {
            display: none;
        }
    }
    
   /*** Mobile Landscape view **/
    @media only screen and (min-device-width: 325px) and  (max-device-width: 500px) and (orientation: landscape) {
        padding-bottom: 120px;
        height: ${({ isCondensedView }) =>
            isCondensedView ? 'calc(100vh - 15rem)': 'calc(100vh - 27rem)'};
    }
    
    @media only screen and (min-device-width: 768px) and (max-device-width: 1200px) and (orientation: portrait) {
            height: ${({ bannerHeight }) =>
                `calc(100vh - 32.5rem - ${bannerHeight || '0px'})`
            };
        }
 
    @media only screen and (width: 768px) and (orientation: portrait) {
    height: ${({ isCondensedView, isFromIndependentProductGuide, bannerHeight, isFilterAppliedIndependentPG }) =>
        (isCondensedView && !isFromIndependentProductGuide) ? 'calc(100vh - 30rem)' :
        (isFromIndependentProductGuide && isFilterAppliedIndependentPG && bannerHeight) ? `calc(100vh - 38rem - ${bannerHeight})` :
        (isFromIndependentProductGuide && !isFilterAppliedIndependentPG && bannerHeight) ? `calc(100vh - 35rem - ${bannerHeight})` :
        'calc(100vh - 35rem)'
    };
    }
 
    @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
        padding-bottom: 120px;
        height: ${({ lgCartHeight }) =>
            lgCartHeight ? lgCartHeight : 'calc(100vh - 29rem)'};
    }
 
    /*** Mobile Landscape view **/
    @media only screen and (min-device-width: 325px) and
            (max-device-width: 500px) and (orientation: landscape) {
        padding-bottom: 120px;
        height: ${({ isCondensedView }) =>
        isCondensedView ? 'calc(100vh - 15rem)': 'calc(100vh - 27rem)'};
    }
    @media only screen and (width: 810px) and (height: 1080px) and (orientation: portrait) {
        height: calc(100vh - 36rem)     
    };
`;

export const CartContainer = styled.div`
    grid-template-columns: 48% 50%;
    column-gap: 15px;
    row-gap: 15px;
    display: grid;
    overflow-x: hidden;
    ${media.smalDevice`
        grid-template-columns: 100%;
    `}
    ${media.largeDevice`
        grid-template-columns: 100%;
    `}
    ${media.mobileDevice`
        row-gap: 10px;
    `}
`;
export const ItemTable = styled.table`
    width: 100%;
    ${'' /* border-collapse: separate; */}
    border-spacing: 0;
    font-family: ${({ fontFamily }) =>
        fontFamily && fontFamily};
    font-size: 14px;
    border-bottom: 1px solid #ddd;
    table-layout: fixed;
    border-collapse: collapse;
`;

export const MobileView = styled.div`
    display: none;
    ${media.mobileDevice`
        display: block;
    `}
`;

export const DesktopView = styled.div`
    display: block;
    margin-top:  ${({ paginationMarginTop }) => (paginationMarginTop ? paginationMarginTop : '0')};
    
    ${media.mobileDevice`
        display: none;
    `}
    
    ${media.mediumDevice}

    .product-guid-custom-pagination {
        // position: fixed;
        width: ${({ width }) => (width ? width : '98.5%')};
        max-width: ${({ maxWidth }) => maxWidth && maxWidth};
        bottom: 0;
        background-color: white;
        padding-top: ${({ paddingTop }) => paddingTop && paddingTop};
        ${media.mobileDevice`
            position: relative;
            width: 100%;
            bottom: 0;
        `}
        @media only screen and (min-device-width: 1024px) and (max-device-width: 1026px) {
            width: ${({ isCondensedView }) => isCondensedView && '100%'};
        }
        @media only screen and (min-device-width: 768px) and (max-device-width: 770px) {
            width: ${({ isCondensedView }) => isCondensedView && '100%'};
        }
        @media only screen and (min-device-width: 820px) and (max-device-width: 830px) {
            width: ${({ isCondensedView }) => isCondensedView && '100%'};
        }
        @media only screen and (min-device-width: 768px) and (max-device-width: 1180px) {
             width: 100%
             margin-top: ${({ isCondensedView }) => isCondensedView ? '' : '-100px'};
        }
        ${'' /* @media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (orientation: Landscape) {
            width: 50%
        }
        @media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (orientation: Portrait) {
            width: 50%
        } */}
    }

    #paginatorContainer {
        #paginationInfo {
            ${media.smalDevice`                    
                font-size: 12px;  
            `}
            ${media.mediumDevice`    
                font-size: 12px;
            `}
            @media screen and (min-device-width: 1360px) and (max-device-width: 1370px) and (min-device-height: 1020px) and (max-device-height: 1130px) and (orientation: landscape) {
                font-size: 12px;
                width: 45%;
                margin: 12px 12px;
            }

            @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
                font-size: 12px;
                width: 45%;
                margin: 12px 12px;
            }

            @media screen and (min-device-width: 1070px) and (max-device-width: 1090px) and (min-device-height: 800px) and (max-device-height: 820px) and (orientation: landscape) {
                font-size: 12px;
                width: 40%;
                margin: 12px 8px;
            }

            @media only screen and (min-width: 1110px) and (max-width: 1122px) and (orientation: landscape) {
                font-size: 12px;
                width: 45%;
                margin: 12px 12px;
            }
        }
        .p-paginator {
            @media screen and (min-device-width: 1070px) and (max-device-width: 1090px) and (min-device-height: 800px) and (max-device-height: 820px) and (orientation: landscape) {
                padding: 0.5rem 1rem 0.5rem 0rem;
            }
        }
    }
`;

export const PaginationContainerMobile = styled.div`
    display: flex;
    justify-content: space-between;
    background: ${({ mobileBackground }) => (mobileBackground && mobileBackground )};
    box-shadow: ${({ mobileBoxShadow }) => mobileBoxShadow ? mobileBoxShadow : ''};
    align-items: center;
    margin: 0px;
    width: ${({ mobilePaginationWidth }) => (mobilePaginationWidth ? mobilePaginationWidth : '90%')};
    ${media.mobileDevice`
        flex-direction:column;
         margin: ${({ mbMargin }) => (mbMargin ? mbMargin : '10px 0px 0px 0px')};
        justify-content: space-between;
        position: sticky;
        bottom:0;
    `}
`;

export const TextFont = styled.div`
    font-size: 16px;
    text-align: left;
    color: #140f4b;
`;